import { Fragment } from 'react'

/**
 * Home "about" section: the company copy beside one drawing title block of
 * facts (replaces the old metric card, feature tiles and check badges, which
 * repeated each other). Anchor target of the navbar's #about.
 *
 * @param {{ copy: {
 *   titleLines: string[],
 *   paragraphs: Array<{ before: string, strong: string, after: string }>,
 *   facts: Array<{ key: string, value: string }>,
 * } }} props
 */
export default function AboutSheet({ copy }) {
  return (
    <section id="about" className="home-about" aria-labelledby="about-title">
      <div className="container about-sheet">
        <div className="about-copy">
          <h2 id="about-title">
            {copy.titleLines.map((line, index) => (
              <Fragment key={line}>
                {index > 0 ? <br /> : null}
                {line}
              </Fragment>
            ))}
          </h2>
          {copy.paragraphs.map((paragraph) => (
            <p key={paragraph.strong}>
              {paragraph.before}
              <strong>{paragraph.strong}</strong>
              {paragraph.after}
            </p>
          ))}
        </div>

        <div className="about-facts" data-reveal>
          <table className="spec" aria-labelledby="about-title">
            <tbody>
              {copy.facts.map((fact) => (
                <tr key={fact.key}>
                  <th scope="row">{fact.key}</th>
                  <td>{fact.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
